@if (showAddCheckpointForm) {
  <div class="card dialog-box">
    <div
      class="fw-semibold d-flex gap-2 justify-content-between card-header mb-0 align-items-center"
    >
      @if (nfcReader) {
        <img
          src="assets/images/NFC_logo.avif"
          alt=""
          srcset=""
          width="32"
          height="32"
        />
      } @else {
        <img
          src="assets/images/qr-code-logo.avif"
          alt=""
          srcset=""
          width="32"
          height="32"
        />
      }
      <span>
        Checkpoint Details {{ nfcReader ? "[NFC Tag]" : "[QR Code]" }}
      </span>

      <span (click)="onCloseDialogue()" class="pe-2">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      @if (offlineMode) {
        <div>
          <div class="alert alert-danger small">
            Warning: Connection to server failed. This
            {{ nfcReader ? "NFC Tag" : "QR Code" }} will be uploaded later.
          </div>
        </div>
      }
      <div class="p-2 d-flex column-gap-4 row-gap-2 flex-wrap small">
        <dl>
          <dt>Type</dt>
          <dd>{{ nfcReader ? "NFC" : "QR" }}</dd>
        </dl>
        <dl>
          <dt>Checkpoint ID</dt>
          <dd>
            {{
              checkPointForm.value?.qr_text.length >= 24
                ? "......" +
                  checkPointForm.value?.qr_text.slice(
                    checkPointForm.value?.qr_text.length - 24,
                    checkPointForm.value?.qr_text.length
                  )
                : checkPointForm.value?.qr_text
            }}
          </dd>
        </dl>
        @if (checkPointForm.value?.name && currentStep === 2) {
          <dl>
            <dt>Checkpoint</dt>
            <dd class="fw-semibold">{{ checkPointForm.value.name }}</dd>
          </dl>
          <dl>
            <dt>Site</dt>
            <dd>
              {{ checkPointForm.value.site }} [{{
                checkPointForm.value.company
              }}]
            </dd>
          </dl>
        }
      </div>

      <form [formGroup]="checkPointForm">
        @if (currentStep === 1) {
          <div class="row row-cols-1 g-2">
            <div class="input-group">
              <div class="form-floating">
                <input
                  class="form-control"
                  formControlName="name"
                  id="cpName"
                  type="text"
                  [maxlength]="100"
                  placeholder="Checkpoint Name Placeholder"
                  value="Checkpoint Name Value"
                  autocomplete="off"
                />
                <label for="cpName">Checkpoint Name</label>
              </div>
              @if (checkPointForm.value.name) {
                <span class="input-group-text" (click)="editField('name')">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
            @if (checkPointForm.value.site_id) {
              <div>
                <dl>
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Site</dt>
                      <dd>
                        {{ checkPointForm.value.site }}
                        <div>[{{ checkPointForm.value.company }}]</div>
                      </dd>
                    </div>
                    <div>
                      <span (click)="editField('site')">
                        <i
                          class="fa-solid fa-pen-to-square md-font-size text-secondary"
                        ></i
                      ></span>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (!checkPointForm.value.site_id) {
              <div>
                <gtapp-auto-complete
                  [data]="siteListData"
                  placeHolder="Site"
                  searchKeyword="company_name"
                  [initialValue]="checkPointForm.value.site"
                  [itemTemplate]="siteTemplate"
                  [addInitialKey]="(isAdmin || isDispatchUser) && !offlineMode"
                  (inputChanged)="onSiteSearch($event)"
                  (selected)="onSiteSelect($event)"
                  inputId="siteId"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('site')"
                >
                </gtapp-auto-complete>
              </div>
            }
            <ng-template #siteTemplate let-item>
              @if (item?.key === 0) {
                @if (!offlineMode) {
                  <div>Create New Site</div>
                }
              } @else {
                <div>
                  <div class="fw-medium">
                    {{ item?.company_name }} [{{ item?.company?.company_name }}]
                  </div>
                  <div class="small-font text-secondary">
                    {{ item?.address?.full_address }}
                  </div>
                </div>
              }
            </ng-template>
            <div class="form-floating">
              <input
                class="form-control"
                id="description"
                formControlName="description"
                type="text"
                placeholder="Description (Optional)"
              />
              <label for="inputAssignee">Description (Optional)</label>
            </div>
            <div class="mt-4 mb-5">
              <div class="form-check mb-3 d-flex align-items-center">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="registerScan"
                  (change)="registerScan = !registerScan"
                  [checked]="registerScan"
                />
                <label class="form-check-label" for="registerScan"
                  >Scan Checkpoint After Adding</label
                >
              </div>
              @if (isAdmin || isDispatchUser) {
                <div class="form-check mb-3 d-flex align-items-center">
                  <input
                    class="form-check-input me-2"
                    [disabled]="offlineMode"
                    type="checkbox"
                    id="lockQRCp"
                    [checked]="checkPointForm.value.is_locked"
                    (change)="showHideAddressFields($event)"
                  />
                  <label class="form-check-label" for="lockQRCp"
                    >Set Location & Lock Checkpoint</label
                  >
                  <span
                    class="ms-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="When ticked, checkpoint can only be scanned at checkpoint location."
                  >
                    <i class="fa-solid fa-circle-info"></i>
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="row row-cols-2">
            <div class="col">
              <button
                type="button"
                (click)="onCloseDialogue()"
                class="btn btn-dark btn-lg w-100"
              >
                Cancel
              </button>
            </div>
            @if (isAdmin || isDispatchUser) {
              @if (checkPointForm.value.is_locked) {
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg w-100"
                    [disabled]="
                      !checkPointForm.value.site_id ||
                      !checkPointForm.value.name
                    "
                    (click)="showMapMethod(); currentStep = 2"
                  >
                    Set Location
                  </button>
                </div>
              } @else {
                <div class="col">
                  <button
                    type="submit"
                    [disabled]="
                      !checkPointForm.value.site_id ||
                      !checkPointForm.value.name
                    "
                    class="btn btn-primary btn-lg w-100"
                    (click)="onClickSubmit()"
                  >
                    Add Checkpoint
                  </button>
                </div>
              }
            } @else {
              <div class="col">
                <button
                  type="submit"
                  [disabled]="
                    !checkPointForm.value.site_id || !checkPointForm.value.name
                  "
                  class="btn btn-primary btn-lg w-100"
                  (click)="onClickSubmit()"
                >
                  Add Checkpoint
                </button>
              </div>
            }
          </div>
        }
        @if (currentStep === 2) {
          <div class="row row-cols-2 my-2">
            <div class="col">
              <button
                (click)="
                  currentStep = 1;
                  initializeToolTip();
                  showAddressLookupForm('forward')
                "
                class="btn btn-dark btn-lg w-100"
              >
                Back
              </button>
            </div>

            <div class="col">
              <button
                [disabled]="
                  !checkPointForm.value.site_id ||
                  !checkPointForm.value.name ||
                  !checkPointForm.value?.latitude ||
                  !checkPointForm.value?.longitude ||
                  !checkPointForm.value?.min_distance
                "
                class="btn btn-primary btn-lg w-100"
                (click)="onClickSubmit()"
              >
                Add Checkpoint
              </button>
            </div>
          </div>

          <div>
            <div class="mb-2">
              <gtapp-address-lookup
                [addressForm]="checkPointForm"
                showLookupFrom="addCheckpoint"
                (updateAddress)="addressSelected($event)"
              >
              </gtapp-address-lookup>
            </div>
            <gtapp-map-leaflet
              [latLon]="{
                lat: checkPointForm.value?.latitude,
                lon: checkPointForm.value?.longitude,
              }"
              [mapId]="'checkpointEditmapid'"
              [changableRadius]="true"
              [cursorDraggable]="true"
              (emitData)="emitData($event)"
              (updateMinDistance)="updateMinDistance($event)"
            ></gtapp-map-leaflet>
            @if (
              checkPointForm.value?.latitude && checkPointForm.value?.longitude
            ) {
              <div class="text-center small">
                <div>Drag the marker to set coordinates</div>
              </div>
            }
          </div>
        }
      </form>
    </div>
  </div>
} @else {
  @if (nfcReader) {
    <ng-container>
      <div class="dialog-box card border-0 p-3">
        @if (nfcErrorOutput) {
          <div class="alert text-danger fw-bold mb-0">
            {{ nfcErrorOutput }}
          </div>
        } @else {
          <div class="alert alert-primary my-3 d-flex align-items-center">
            <div class="spinner-grow me-2" role="status"></div>
            <div class="fw-bold flex-grow-1">
              Place your device on the NFC tag
            </div>
          </div>
          <div class="text-center my-3 justify-content-center d-flex">
            <div class="rounded">
              <img
                src="assets/gif/nfc_scan.gif"
                alt=""
                srcset=""
                width="200"
                height="200"
                class="rounded"
              />
            </div>
          </div>
        }

        <div class="row row-cols-1 pt-3">
          <div class="col">
            <button
              class="btn btn-secondary btn-md w-100"
              (click)="onCloseDialogue()"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  } @else {
    <div class="dialog-box card bg-black border-0">
      @if (isNativeApp) {
        <div class="text-white"></div>
        @if (
          nativeAppCameraPermission.permissionDenied ||
          nativeAppCameraPermission.otherError
        ) {
          <div>
            @if (nativeAppCameraPermission.permissionDenied) {
              <div class="text-danger mb-4 fw-semibold">
                Unable to access your camera feed, please check your app
                permissions and ensure camera access is allowed.
              </div>
              <div class="text-center">
                <button
                  class="btn btn-primary w-75 btn-md"
                  (click)="openSettings()"
                >
                  Open Settings
                </button>
              </div>
            } @else {
              <div class="alert text-light small mb-0">
                <div class="mb-1">
                  There was a problem getting your camera feed, please try the
                  following.
                </div>
                <ol>
                  @if (cameraDevices.length > 1) {
                    <li>Switch to another camera (if available).</li>
                  }
                  <li>
                    Check your app permissions and ensure camera access is
                    allowed.
                  </li>

                  <li>Close and reopen the app, and try again.</li>
                  <li>
                    Power off your device, wait 5 seconds, power on and try
                    again.
                  </li>
                </ol>
              </div>
            }
          </div>
        } @else {
          <div>
            <div class="d-flex align-items-center justify-content-between">
              <button
                class="btn btn-secondary btn-md"
                (click)="onCloseDialogue()"
              >
                Cancel
              </button>
              @if (isTorchAvailable) {
                <button
                  id="torchBtn"
                  class="btn btn-md"
                  [ngClass]="
                    devieTorchOn ? 'text-danger border-danger' : 'btn-primary'
                  "
                  (click)="turnOffOnTorchNativeApp(devieTorchOn ? 'off' : 'on')"
                >
                  {{ devieTorchOn ? "Turn Off Torch" : "Turn On Torch" }}
                </button>
              }
              @if (nativeCameraCapabilities?.cameras?.length > 1) {
                <button
                  class="btn btn-light btn btn-md"
                  (click)="cycleCamera()"
                >
                  <i class="fa-solid fa-2x fa-camera-rotate"></i>
                </button>
              }
            </div>
          </div>
          <div class="native-qr-scanner">
            <div id="qr-scanner" class="my-4"></div>
          </div>
          @if (zoomValuesAvailable?.length) {
            <div>
              <div
                class="row"
                [ngClass]="'row-cols-' + zoomValuesAvailable.length"
              >
                @for (zoom of zoomValuesAvailable; track $index) {
                  <div class="col">
                    <button
                      class="btn btn-sm w-100"
                      [ngClass]="
                        selectedZoom === zoom
                          ? 'btn-light'
                          : 'btn-outline-light'
                      "
                      (click)="applyZoom(zoom)"
                    >
                      {{ zoom }}x
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        }
      } @else {
        @if (isIphonePwa) {
          <div
            (click)="toggleCollapse()"
            class="btn btn-sm btn-primary text-center mb-2"
          >
            Help
          </div>
          <div class="small collapse text-light" id="collapseId">
            If you don't see a camera feed, try the following:
            <ol>
              <li>
                Close and reopen Guard Tracker, and try again. Tap
                <span class="fw-semibold text-primary">Allow</span> when
                prompted for access to camera.
              </li>
              <li>Run Guard Tracker in a new tab in your web browser.</li>
              <li>
                Turn your phone off and on via Settings > General > Shut Down.
              </li>
            </ol>
          </div>
        }
        @if (!cameraFeedDetected && !isIphonePwa) {
          <div class="alert text-light small mb-0">
            <div class="mb-1">
              There was a problem getting your camera feed, please try the
              following.
            </div>
            <ol>
              @if (cameraDevices.length > 1) {
                <li>Switch to another camera (if available).</li>
              }
              <li>
                Check your browser permissions and ensure camera access is
                allowed.
              </li>
              <li>Try running Guard Tracker in a new browser tab.</li>
              <li>Close and reopen your browser, and try again.</li>
              <li>
                Power off your device, wait 5 seconds, power on and try again.
              </li>
            </ol>
          </div>
        }
        <div>
          <div
            [class.camera-top-options]="
              cameraFeedDetected && !videoElementHidden
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <button
                class="btn btn-secondary btn-md"
                (click)="onCloseDialogue()"
              >
                Cancel
              </button>
              @if (isTorchAvailable) {
                <button
                  id="torchBtn"
                  class="btn btn-md"
                  [ngClass]="
                    devieTorchOn ? 'text-danger border-danger' : 'btn-primary'
                  "
                  (click)="turnOffOnTorchHTML5(devieTorchOn ? 'off' : 'on')"
                >
                  {{ devieTorchOn ? "Turn Off Torch" : "Turn On Torch" }}
                </button>
              }
              @if (!videoElementHidden && cameraDevices?.length > 1) {
                <button
                  class="btn btn-light btn btn-md"
                  (click)="cycleCamera()"
                >
                  <i class="fa-solid fa-2x fa-camera-rotate"></i>
                </button>
              }
            </div>
          </div>
          <div id="html5-qr-reader" class="html5-qr-reader mb-2"></div>
          @if (zoomValuesAvailable?.length) {
            <div>
              <div
                class="row"
                [ngClass]="'row-cols-' + zoomValuesAvailable.length"
              >
                @for (zoom of zoomValuesAvailable; track $index) {
                  <div class="col">
                    <button
                      class="btn btn-sm w-100"
                      [ngClass]="
                        selectedZoom === zoom
                          ? 'btn-light'
                          : 'btn-outline-light'
                      "
                      (click)="applyZoom(zoom)"
                    >
                      {{ zoom }}x
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (
        (cameraFeedDetected && cameraDevices?.length && !videoElementHidden) ||
        (isNativeApp &&
          !(
            nativeAppCameraPermission.permissionDenied ||
            nativeAppCameraPermission.otherError
          ))
      ) {
        <div class="d-flex align-items-center text-white mb-3">
          <div
            class="form-check d-flex justify-content-center align-items-center gap-2 my-4 mx-auto"
          >
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="continuousQRScan"
              (change)="continuousQRScan = !continuousQRScan"
              type="checkbox"
              id="continousQRScan"
            />
            <label class="form-check-label" for="continousQRScan">
              Scan Multiple / Keep Camera On
            </label>
          </div>
        </div>
      }
    </div>
  }
}

<ng-template
  #qrScanWarningTemplate
  let-data
  let-qrScanWarningTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Warning
      <span class="float-end" (click)="qrScanWarningTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-2">
      You are outside the checkpoint radius. Ignore and scan anyway?
    </div>

    <div class="row row-cols-2 mb-2">
      <div class="col">
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="qrScanWarningTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col" (click)="qrScanWarningTemplateRef.close(true)">
        <button class="btn btn-primary btn-lg w-100">Ignore</button>
      </div>
    </div>

    @if (data?.gps?.lat && data?.scan_detail?.lat && data?.min_distance) {
      <gtapp-map-leaflet
        [latLon]="data?.gps"
        [scannedCheckpointDetails]="data"
        mapId="checkPointGeoCheckMapId"
      ></gtapp-map-leaflet>
    }</div
></ng-template>
